"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidURL = isValidURL;
exports.isValidURLOrURN = isValidURLOrURN;
exports.redirectURIValidator = redirectURIValidator;
exports.urlValidator = urlValidator;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _urlregex = _interopRequireDefault(require("urlregex"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// URL part updated to scheme = alpha *( alpha | digit | "+" | "-" | "." ) according to RFC 2396
var urlOrUrn = /(^urn:[a-z0-9][a-z0-9-]{1,31}:([a-z0-9()+,.:=@;$_!*'-]|%[0-9a-f]{2})+$)|(^[a-z][a-z0-9+.-]+:\/\/[\w-]+(?:\.[\w-]+)*(:\d+)?(?:\/\S*)?$)/i; // NOSONAR

/**
 * Check URL validity
 * @param  {String}
 * @return {Boolean}
 */
function isValidURL() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !!value && typeof value === 'string' && (0, _urlregex.default)(_objectSpread({
    tld: false
  }, options)).test(value);
}

/**
 * Check URL/URN validity
 * @param  {String}
 * @return {Boolean}
 */
function isValidURLOrURN() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return urlOrUrn.test(value);
}
function urlValidator() {
  return {
    validURL: {
      validate: function validate(_ref) {
        var value = _ref.value;
        return !value || isValidURL(value);
      },
      message: 'Please provide a valid URL'
    }
  };
}
function redirectURIValidator() {
  return {
    validRedirectUri: {
      validate: function validate(_ref2) {
        var value = _ref2.value;
        if (!value) {
          return true;
        }
        return value.split(',').every(function (part) {
          return isValidURLOrURN(part.trim());
        });
      },
      message: 'At least one of provided URIs is invalid'
    }
  };
}
//# sourceMappingURL=validations.js.map